/**
 * apps.key is snake_case (`running_title`); the `/a/<slug>` route segment is
 * kebab-case (`running-title`). RequireApp / user_app_access always deal in
 * the underscored key — only the URL itself is hyphenated.
 */
export const appKeyToSlug = (key: string): string => key.replace(/_/g, '-');

export const appSlugToKey = (slug: string): string => slug.replace(/-/g, '_');
